import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoaderProgressService } from './loader-progress.service';
import { MakingWavesLoaderService } from '../../services';
import { BytesToMbPipe } from '../../pipes/bytes-to-mb.pipe';
import { ToProgressPercentagePipe } from '../../pipes/to-progress-percentage.pipe';

@Component({
    selector: 'making-waves-loader',
    templateUrl: './making-waves-loader.component.html',
    styleUrls: ['./making-waves-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatProgressBarModule, BytesToMbPipe, ToProgressPercentagePipe]
})
export class MakingWavesLoaderComponent {
  public loaderProgressService = inject(LoaderProgressService);
  public loaderService = inject(MakingWavesLoaderService);
}
